var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper",
      style: {
        backgroundImage: "url(" + _vm.image.ImgthumbBlurLarge + ")",
        backgroundPosition: "0 0"
      }
    },
    [
      _c("div", {
        staticClass: "colorOverlay",
        style: {
          background: "#000",
          opacity: 0.3
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "colorOverlay",
        style: {
          background:
            "linear-gradient(45deg, #" +
            _vm.content.colordark +
            ", #" +
            _vm.content.colorlight +
            ")"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper__stats" }, [
        _c(
          "ul",
          _vm._l(Object.keys(_vm.keyStats), function(label) {
            return _c("li", { key: "stat-" + label }, [
              _c("h5", [_vm._v(_vm._s(label))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.keyStats[label]))])
            ])
          })
        )
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.content.caption))]),
      _vm._v(" "),
      _vm.footerStats
        ? _c("div", { staticClass: "wrapper__stats" }, [
            _c("hr"),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(Object.keys(_vm.footerStats), function(label) {
                return _c("li", { key: "stat-" + label }, [
                  _c("h5", [_vm._v(_vm._s(label))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.footerStats[label]))])
                ])
              })
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10c5d468", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10c5d468","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dally-m/team-bottom.vue
// module id = null
// module chunks = 